import React from 'react';
import { Modal, Button } from 'antd';
import OrderConfirmModalFooter from '../confirm-modal/OrderConfirmModalFooter';

export default function OrderSendToQcModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  onMoveBack,
  showMoveBack,
  order,
  loading,
}) {
  return (
    <Modal
      title="Send to QC team"
      className="order-confirm-modal"
      width={480}
      open={!!open}
      onCancel={onCancel}
      footer={(
        <OrderConfirmModalFooter>
          <Button
            type="primary"
            onClick={onConfirmYes}
            loading={loading}
            className="app-btn-primary"
          >
            Yes, send to QC
          </Button>
          <Button
            onClick={onConfirmNo}
            loading={loading}
            className="app-btn-cancel"
          >
            No, keep pending
          </Button>
          {showMoveBack && onMoveBack && (
            <Button onClick={onMoveBack} loading={loading} className="app-btn-cancel">
              Move back to Open
            </Button>
          )}
        </OrderConfirmModalFooter>
      )}
      destroyOnClose
    >
      {order && (
        <>
          Are you sure you want to send this order to QC team?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
